export default {"src":"/_next/static/media/icone-potential.c099afdb.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};